/**
 * Sincronizzazione del portafoglio dal suo broker (TODO.md).
 *
 * La sync esisteva già ma solo nella pagina Connessioni, che è il posto in cui
 * si *configura* il collegamento — non quello in cui si guarda il portafoglio e
 * ci si accorge che i numeri sono vecchi. È lì che serve il comando.
 *
 * ## Cosa NON fa
 *
 * Non è un pulsante di trading: la sincronizzazione **legge soltanto**, importa
 * posizioni e movimenti. Il testo lo dice, perché su una pagina che ora ospita
 * anche l'invio di ordini la distinzione non può essere lasciata all'intuito.
 *
 * ## Perché può restare invisibile
 *
 * Un portafoglio senza connessione broker attiva non ha nulla da sincronizzare.
 * Qui il controllo **non** compare del tutto, a differenza del precedente di
 * F-051 («visibile ma disabilitato con la ragione»): là la funzione esisteva ed
 * era negata a quell'utente, qui non esiste proprio per quell'oggetto — un
 * portafoglio da import CSV non ha un broker da interrogare, e un pulsante
 * spento suggerirebbe che gliene manchi uno.
 */

import { ApiError } from '@/lib/api-client';
import { formatDateTime } from '@/lib/format';
import { useConnections, useSyncConnection } from '@/features/connectors/api';
import { Button } from '@/ui';

export function PortfolioSyncButton({ portfolioId }: { portfolioId: string }) {
  const connections = useConnections();
  const sync = useSyncConnection();

  const connection = (connections.data?.items ?? []).find(
    (item) => item.portfolio.id === portfolioId && item.status === 'active',
  );
  if (!connection) return null;

  const error = sync.error instanceof ApiError ? sync.error : null;

  return (
    <span className="portfolios__sync">
      <Button
        variant="secondary"
        loading={sync.isPending}
        onClick={() => sync.mutate(connection.id)}
        title={`Importa posizioni e movimenti da ${connection.label}. Legge soltanto: non invia ordini.`}
      >
        {sync.isPending ? 'Sincronizzo…' : 'Sincronizza'}
      </Button>
      {/* Lo stato dell'ultima sincronizzazione accanto al comando: senza, dopo
          il primo giro l'utente non ha modo di sapere se i numeri che sta
          guardando sono quelli appena importati o quelli di ieri. */}
      {sync.isSuccess ? (
        <span className="portfolios__sync-note">sincronizzato adesso</span>
      ) : error ? (
        <span className="portfolios__sync-error">{error.message}</span>
      ) : connection.lastSyncAt ? (
        <span className="portfolios__sync-note">ultima: {formatDateTime(connection.lastSyncAt)}</span>
      ) : (
        <span className="portfolios__sync-note">mai sincronizzato</span>
      )}
    </span>
  );
}
